import { Icon, IconSize } from '@vwfs-bronson/bronson-react';
import React from 'react';

export const RenderFormSectionSummaryTitle = (title: string, isDisabledFormSummary: boolean) => {
  return (
    <>
      {isDisabledFormSummary && (
        <span className="u-mr">
          <Icon size={IconSize.SMALL} name="semantic-lock" />
        </span>
      )}
      <span>{title}</span>
    </>
  );
};
